import { CancelOutlined } from "@mui/icons-material";
import { Box, Dialog, IconButton, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import Checkbox from "../Checkbox";
import LoaderStyleOne from "../Loaders/LoaderStyleOne";
import { ErrorToaster, SuccessToaster } from "../toaster/Toaster";
import CommonServices from "../../../apis/common/CommonServices";
import { useAuth } from "../../../context/UseContext";
import { DropShipperTypeId } from "../../../utils";
import ProductServices from "../../../apis/product/ProductServices";

export default function SelectStoreModal(props) {
  const { open, close, productId } = props;
  const { user } = useAuth();

  const [loading, setLoading] = useState(false);

  // *For External Store
  const [externalStores, setExternalStores] = useState();
  const [storeIds, setStoreIds] = useState([]);

  // *For Get External Store
  const getUserExternalStores = async (search, page, limit) => {
    try {
      let params = {
        page: 1,
        limit: 30
      }
      const { data } = await CommonServices.getUserExternalStores(params)
      setExternalStores(data.filter(e => e.is_connected !== 0))
    } catch (error) {
      ErrorToaster(error)
    }
  }

  const handleSelectStore = (storeId) => {
    try {
      let updatedStoreIds;

      if (storeIds.includes(storeId)) {
        // Remove store ID if already exists
        updatedStoreIds = storeIds.filter(id => id !== storeId);
      } else {
        // Add store ID if not exists
        updatedStoreIds = [...storeIds, storeId];
      }
      setStoreIds(updatedStoreIds);
    } catch (error) {
      console.log('handleSelectStore => error:', error)
    }
  }

  // *For Add Product into DropShipper External Store
  const addToList = async () => {
    setLoading(true)
    try {
      if (storeIds.length == 0) {
        ErrorToaster('Please select store')
        return
      }
      let obj = {
        store_id: storeIds,
        product_id: productId
      }
      const { message } = await ProductServices.addProductToList(obj)
      SuccessToaster(message)
      close()
    } catch (error) {
      ErrorToaster(error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (user?.type == DropShipperTypeId && user?.is_plan_active == 1) {
      getUserExternalStores()
    }
  }, []);

  return (
    <Dialog
      open={open}
      sx={{ '& .MuiDialog-paper': { width: { xs: '90%', sm: '80%', md: '40%' }, height: "auto", borderRadius: 2, py: { xs: 2, md: 4 }, px: { xs: 3, md: 6 } } }}
    >
      <IconButton onClick={() => close()} sx={{ position: 'absolute', right: 13, top: 13 }}>
        <CancelOutlined />
      </IconButton>
      <Typography variant="h5" sx={{ textAlign: 'center', mt: 1, mb: 2.5 }}>
        Select Store
      </Typography>
      <Box>
        <ul>
          {externalStores?.map((item, index) => (
            <li key={index} className="item flex justify-between items-center mb-5 cursor-pointer">
              <div className="flex space-x-[14px] items-center" onClick={() => handleSelectStore(item.store_id)}>
                <div>
                  <Checkbox
                    checked={storeIds?.includes(item.store_id)}
                  />
                </div>
                <div>
                  <label className="text-xs font-black font-400 capitalize cursor-pointer">
                    {item?.store_type}
                  </label>
                </div>
              </div>
            </li>
          ))}
        </ul>
        <div
          data-aos="fade-up"
          className="quantity-card-wrapper w-full flex items-center h-[50px] space-x-[10px]"
        >
          <div className="flex-1 h-full">
            <button
              type="button"
              onClick={() => addToList()}
              className="text-sm font-semibold w-full h-full flex justify-center items-center"
              style={{ backgroundColor: '#000000', color: '#fff' }}
              disabled={loading}
            >
              <div className="flex items-center space-x-3">
                <span>
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/hashtag-logo-white.png`}
                    alt="hashtag"
                    className="add-to-list-icon"
                  />
                </span>
                <span>
                  Add To List
                </span>
                {loading && (
                  <span className="w-3 " style={{ transform: "scale(0.3)" }}>
                    <LoaderStyleOne />
                  </span>
                )}
              </div>
            </button>
          </div>
        </div>
      </Box>
    </Dialog>
  );
}
